import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../base/Logo';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="mb-4">
              <Logo size="lg" variant="dark" />
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              北京生因科技有限公司是一家专注于生命科学领域的科研服务公司，面向科研院所、制药企业和医疗机构，提供多维度的实验技术支持与数据分析服务，助力科学研究、药物研发与精准医疗。
            </p>
            <div className="flex space-x-4">
              <Link
                to="/contact"
                className="text-gray-400 hover:text-white transition-colors duration-200"
                aria-label="微信"
              >
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-wechat-line text-xl"></i>
                </div>
              </Link>
              <Link
                to="/contact"
                className="text-gray-400 hover:text-white transition-colors duration-200"
                aria-label="微博"
              >
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-weibo-line text-xl"></i>
                </div>
              </Link>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">服务项目</h4>
            <ul className="space-y-2">
              <li><Link to="/services" className="text-gray-300 hover:text-white transition-colors cursor-pointer">基因组学分析</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-white transition-colors cursor-pointer">转录组学分析</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-white transition-colors cursor-pointer">蛋白质组学分析</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-white transition-colors cursor-pointer">代谢组学分析</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-white transition-colors cursor-pointer">多组学整合分析</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-lg font-semibold mb-4">公司信息</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-300 hover:text-white transition-colors cursor-pointer">关于我们</Link></li>
              <li><Link to="/cases" className="text-gray-300 hover:text-white transition-colors cursor-pointer">服务标准</Link></li>
              <li><Link to="/careers" className="text-gray-300 hover:text-white transition-colors cursor-pointer">人才招聘</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors cursor-pointer">联系我们</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2025 北京生因科技有限公司. 保留所有权利.
          </p>
          <a
            href="https://beian.miit.gov.cn/#/Integrated/index"
            target="_blank"
            rel="noreferrer"
            className="text-gray-400 text-sm hover:text-gray-200"
          >
            京ICP备2025153087号
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
